var exports = {
  "k": "xf61da738--ab854d--container",
};

module.exports = exports;
